import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href
}: ButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      window.location.href = href;
    } else {
      const element = document.getElementById('compra');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg sm:text-xl font-bold text-white transition-colors duration-200 bg-brand-pink rounded-xl hover:bg-brand-darkPink shadow-md hover:shadow-lg ${className}`} data-id="element-215">
      <span className="text-center" data-id="element-216">{children}</span>
    </button>;
}